import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PushSubscriptionRequest,
  PushSubscriptionVapidKey,
} from '@blaze-shared/api-contracts-domain';
import { XhrService } from '@blaze-shared/platform-data-access';

@Injectable({ providedIn: 'root' })
export class PushNotificationsApiService {
  private readonly xhrService = inject(XhrService);

  getKeys(): Observable<PushSubscriptionVapidKey> {
    return this.xhrService.get<PushSubscriptionVapidKey>(`pushnotifications/keys`);
  }

  sendSubscription(request: PushSubscriptionRequest): Observable<void> {
    return this.xhrService.post<void, PushSubscriptionRequest>(
      `pushnotifications/subscribe`,
      request,
    );
  }
}
